import { render } from "./Index_new.vue?vue&type=template&id=0c402d8f"
import script from "./Index_new.vue?vue&type=script&lang=js"
export * from "./Index_new.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src4153154969/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__